import { Component, inject } from "@angular/core";
import { EmptystateComponent } from "@ankaadia/ui";
import { TranslocoService } from "@jsverse/transloco";
import { map } from "rxjs";
import { SettingsService } from "../../../shared/services/settings.service";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { ProcessTaskIcon } from "../../process-models/process-model-item/process-model-item.model";
import { NewUiDashboardCardHeaderComponent } from "../layout/new-ui-dashboard-card-header/new-ui-dashboard-card-header.component";
import { NewUiDashboardCardComponent } from "../layout/new-ui-dashboard-card/new-ui-dashboard-card.component";
import { NewUiDashboardListComponent } from "../layout/new-ui-dashboard-list/new-ui-dashboard-list.component";
import { NewUiDashboardService } from "../new-ui-dashboard.service";
import { derivedAsync } from "ngxtension/derived-async";
import { Skeleton } from "primeng/skeleton";

@Component({
  selector: "new-ui-dashboard-open-tasks",
  templateUrl: "./new-ui-dashboard-open-tasks.component.html",
  imports: [
    NewUiDashboardCardHeaderComponent,
    TranslateDirective,
    NewUiDashboardCardComponent,
    NewUiDashboardListComponent,
    EmptystateComponent,
    Skeleton,
  ],
})
export class NewUiDashboardOpenTasksComponent {
  private readonly newUiDashboardService = inject(NewUiDashboardService);
  protected readonly settings = inject(SettingsService);

  private readonly transloco = inject(TranslocoService);

  private readonly colorClasses = [
    { text: "text-violet-600", background: "bg-violet-600" },
    { text: "text-emerald-600", background: "bg-emerald-600" },
    { text: "text-sky-600", background: "bg-sky-600" },
  ] as const;

  readonly openTaskMetric = derivedAsync(() =>
    this.newUiDashboardService.getOpenTasksMetric().pipe(
      map((res) => {
        // Group tasks by name and type, counting duplicates
        const taskMap = new Map<string, { task: (typeof res.openTasks)[0]; count: number }>();

        res.openTasks.forEach((task) => {
          const key = `${task.taskName}-${task.taskType}`;
          if (taskMap.has(key)) {
            taskMap.get(key).count++;
          } else {
            taskMap.set(key, { task, count: 1 });
          }
        });

        return {
          taskCounts: res.openTaskCount,
          tasks: Array.from(taskMap.values()).map(({ task }, index) => {
            const color = this.colorClasses[index % this.colorClasses.length];

            return {
              rowIcon: ProcessTaskIcon[task.taskType + "Model"],
              rowIconStyleClass: color.text,
              name: task.taskName,
              group: this.transloco.translate(`enum.ProcessTask.${task.taskType}`),
              routeLink: `processes/tasks`,
              queryParams: { search: task.taskName },
              count: task.openTaskCount,
              countColor: color.background,
            };
          }),
        };
      })
    )
  );
}
